'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useDividerBase_unstable: function() {
        return useDividerBase_unstable;
    },
    useDivider_unstable: function() {
        return useDivider_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const useDivider_unstable = (props, ref)=>{
    const { alignContent = 'center', appearance = 'default', inset = false, ...rest } = props;
    const state = useDividerBase_unstable(rest, ref);
    return {
        alignContent,
        appearance,
        inset,
        ...state
    };
};
const useDividerBase_unstable = (props, ref)=>{
    const { vertical = false, wrapper, ...rest } = props;
    const dividerId = (0, _reactutilities.useId)('divider-');
    return {
        vertical,
        components: {
            root: 'div',
            wrapper: 'div'
        },
        root: _reactutilities.slot.always({
            role: 'separator',
            'aria-orientation': vertical ? 'vertical' : 'horizontal',
            'aria-labelledby': props.children ? dividerId : undefined,
            ref: ref,
            ...rest
        }, {
            elementType: 'div'
        }),
        wrapper: _reactutilities.slot.always(wrapper, {
            defaultProps: {
                id: dividerId,
                children: props.children
            },
            elementType: 'div'
        })
    };
};
